<template>
    <div>
        <div v-for="(item, index) in sections" :key="`section-${index}`">
            <component v-bind:is="item.component" v-bind="item"></component>
        </div>
    </div>
</template>

<script>
    import SectionStatistics from './components/organisms/page-sections/OrganismSectionStatistics.vue';
    import SectionWysiwyg from './components/organisms/page-sections/OrganismSectionWysiwyg.vue';
    import SectionFeaturedRequests from './components/organisms/page-sections/OrganismSectionFeaturedRequests.vue';
    import SectionFeaturedCompanies from './components/organisms/page-sections/OrganismSectionFeaturedCompanies.vue';
    import SectionCards from './components/organisms/page-sections/OrganismSectionCards.vue';
    import SectionInstructions from './components/organisms/page-sections/OrganismSectionInstructions.vue';
    import SectionTestimonials from './components/organisms/page-sections/OrganismSectionTestimonials.vue';
    import SectionRatings from './components/organisms/page-sections/OrganismSectionRatings.vue';
    import SectionContactForm from './components/organisms/page-sections/OrganismSectionContactForm.vue';
    import SectionRequestPuff from './components/organisms/page-sections/OrganismSectionRequestPuff.vue';

    export default {
        components: {
        SectionStatistics,
        SectionFeaturedRequests,
        SectionFeaturedCompanies,
        SectionWysiwyg,
        SectionCards,
        SectionInstructions,
        SectionTestimonials,
        SectionRatings,
        SectionContactForm,
        SectionRequestPuff
        },
        props:{
            sections: Array
        }
    }

</script>



// WEBPACK FOOTER //
// src/views/SectionsWrapper.vue